import { Suspense } from "react";
import { AllTokens } from "gql/graphql";
import { Guard } from "@/shared/security/model/guard/guard";
import { HOME_PATH, Home } from "./pages/home";
import { OAUTH_SETTINGS_PATH, OauthSettings } from "./pages/oauth-settings";
import {
  HOLIDAY_SETTINGS_PATH,
  HolidaySettings,
} from "./pages/holiday-settings";
import { SETTINGS_PATH, Settings } from "../user-settings/pages/settings";
import { COMPANY_STRUCTURE_PATH, Main } from "./pages/company-structure/main";
import {
  Notifications,
  NOTIFICATIONS_PATH,
} from "@/modules/common/pages/notifications";
import {
  COMPANY_SETTINGS_PATH,
  CompanySettingsPage,
} from "@/modules/common/pages/company-settings";

export const CommonModule = {
  routes: [
    {
      path: HOME_PATH,
      element: <Home />,
    },
    {
      path: SETTINGS_PATH,
      element: <Settings />,
    },
    {
      path: COMPANY_STRUCTURE_PATH,
      element: <Main />,
    },
    {
      path: OAUTH_SETTINGS_PATH,
      element: (
        <Guard.Redirect.IfCantModify.PageNotFound
          influencedBy={[AllTokens.AdminAccessAuthentication]}
        >
          <OauthSettings />
        </Guard.Redirect.IfCantModify.PageNotFound>
      ),
    },
    {
      path: HOLIDAY_SETTINGS_PATH,
      element: (
        <Guard.Redirect.IfCantModify.PageNotFound
          influencedBy={[AllTokens.AdminCompanyHolidays]}
        >
          <HolidaySettings />
        </Guard.Redirect.IfCantModify.PageNotFound>
      ),
    },
    {
      path: NOTIFICATIONS_PATH,
      element: <Notifications />,
    },
    {
      path: COMPANY_SETTINGS_PATH,
      element: <CompanySettingsPage />,
    },
  ].map((page) => {
    page.element = <Suspense>{page.element}</Suspense>;

    return page;
  }),
};
